import React from 'react';
import { NavLink } from 'reactstrap';
import { ReactComponent as AvatarIcon } from './../../assets/icons/avatars/avatar.svg';
import bell_icon from './../../assets/icons/avatars/bell_icon.svg';

const NavbarUser = (props) => {
  const { name, navLinkData } = props;
  const { key: navKey, className: navClassName, ...restNavLinkData } =
    navLinkData || {};

  return (
    <NavLink
      key={navKey}
      {...restNavLinkData}
      className={'no-border-right ' + (navClassName || '')}
    >
      <span className="truncate user">{name}</span>
      <AvatarIcon className="avatar img-fluid rounded-circle" />
      <img
        src={bell_icon}
        className="bell-icon img-fluid rounded-circle"
        alt="Admin"
      />
    </NavLink>
  );
};

export default NavbarUser;
